<template>
  <table class="level-decrements-table table table-bordered text-nowrap">
    <thead class="thead-dark">
      <tr>
        <th rowspan="2" class="text-right">Ид</th>
        <th rowspan="2">Время</th>
        <th colspan="3" class="text-center">Уровень</th>
      </tr>
      <tr>
        <th class="text-right">старый</th>
        <th class="text-right">новый</th>
        <th class="text-right">разность</th>
      </tr>
    </thead>
    <tr
      v-for="levelDecrement in levelDecrements"
      :key="levelDecrement.id"
    >
      <td class="text-right">{{ levelDecrement.id }}</td>
      <td>{{ getMomentStr(levelDecrement.ctime) }}</td>
      <td class="text-right">{{ getFormattedNumber(levelDecrement.oldLevel) }}</td>
      <td class="text-right">{{ getFormattedNumber(levelDecrement.newLevel) }}</td>
      <td class="text-right">{{ getLevelDifferenceStr(levelDecrement) }}</td>
    </tr>
  </table>
</template>

<script>
import { getLevelDifference } from '../../model/level_decrement.js';
import { getMomentStr       } from '../../util.js';
import { getFormattedNumber } from '../../util.js';

export default {
  name: 'PlayerLevelDecrementsTable',

  props: {
    levelDecrements: {
      type: Array,
      required: true,
    },
  },

  methods: {
    getLevelDifferenceStr(levelDecrement) {
      const levelDifference = getLevelDifference(levelDecrement);
      return getFormattedNumber(levelDifference);
    },

    getMomentStr,
    getFormattedNumber,
  },
};
</script>

<style scoped>
.level-decrements-table {
  max-width: 1px;
}
</style>
